import axios from "axios";

import { TTP_API_URL, GOPEOPLE_API_URL } from "../config";
import goPeopleAxios from "./goPeopleAxios";
import {
  getRequestCancellationToken,
  getRequestConfig,
  generateCancellationTokenSource,
  throwCatchedError,
} from "../utils";

let getGroupsCTS;
let getCollaboratorsCTS;
let getEventListCTS;
let getUsersSettingsCTS;
let getContactsCTS;

export const getCollaborators = ({
  token,
  sort,
  search,
  start,
  limit,
  page,
  organizationId,
  isConfigNewsletter = false,
}) => {
  let cancellationTokenSource = generateCancellationTokenSource();
  // getGroupsCTS
  let requestCancellationToken = getRequestCancellationToken(
    getCollaboratorsCTS,
    cancellationTokenSource
  );
  getCollaboratorsCTS = cancellationTokenSource;

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "organization.id",
      value: organizationId,
      operator: "eq",
    },
  ];
  if (isConfigNewsletter) {
    filter.push({ property: "uaStatus", value: "VALIDATED", operator: "like" });
  }
  if (search) {
    filter.push({ property: "name", value: search, operator: "like" });
    filter.push({ property: "email.main", value: 1, operator: "eq" });
  }

  let params = {
    access_token: token,
    sort: JSON.stringify([sort]),
    fields: "*,role,roles,userSettings",
    start: page ? (page - 1) * limit : start,
    filter: JSON.stringify(filter),
    limit: limit && limit,
    nolimit: !limit && 1,
    workspace: "ua",
  };

  let requestConfig = getRequestConfig(params, requestCancellationToken);
  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getGoPeopleCollaborators = async (organizationId, limit, page) => {
  try {
    const response = await goPeopleAxios.get(
      `/organizations/${organizationId}/users`,
      {
        params: {
          limit,
          include: "role",
          offset: (page - 1) * limit,
        },
      }
    );

    return response;
  } catch (error) {
    throw new Error(
      error.response?.message ||
        error.response?.error ||
        error.message ||
        "Erreur inconnue"
    );
  }
};

export const getTmpCollaborators = ({
  token,
  organizationId,
  status,
  search,
}) => {
  let requestUrl = `${TTP_API_URL}/organization/tmp-role`;

  const filter = [
    {
      property: "organization",
      value: organizationId,
      operator: "eq",
    },
    {
      property: "status",
      value: status,
      operator: "eq",
    },
  ];

  if (search) {
    requestUrl = `${TTP_API_URL}/organization/tmp-role/get-by-name`;

    return axios.get(requestUrl, {
      params: {
        access_token: token,
        fields: "*",
        name: search,
        status,
        organization: organizationId,
        workspace: "ua",
      },
    });
  }
  const params = {
    access_token: token,
    fields: "*",
    filter: JSON.stringify(filter),
    nolimit: 1,
    workspace: "ua",
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getGoPeopleTmpCollaborators = async (organizationId, status) => {
  try {
    const response = await goPeopleAxios.get(
      `/organizations/${organizationId}/users`,
      {
        params: { status, include: "role" },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Erreur inconnue"
    );
  }
};

export const getUserByEmail = (token, email) => {
  let fields = ["*", "email", "phone", "role", "roles"];

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "email",
      value: email,
      operator: "eq",
    },
  ];
  const params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    workspace: "ua",
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const checkUserByEmail = async (email) => {
  try {
    const filter = JSON.stringify({ email });

    const response = await goPeopleAxios.get("/users", {
      params: { filter },
    });

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Erreur inconnue"
    );
  }
};

export const getUsersByEmail = (token, emails) => {
  let fields = ["*", "email", "phone", "role", "roles"];

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "email",
      value: emails,
      operator: "in",
    },
  ];

  const params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    workspace: "ua",
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getUserById = (token, id) => {
  let fields = ["*", "email", "phone", "role", "roles"];

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "id",
      value: id,
      operator: "eq",
    },
  ];

  const params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    workspace: "ua",
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getGoPeopleUserByUUId = async (uuId) => {
  try {
    const response = await goPeopleAxios.get(`/users/${uuId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération de l'utilisateur ${uuId}`
    );
  }
};

export const detachUserAssociations = (token, userId, $organizationId) => {
  const requestUrl = `${TTP_API_URL}/organization/user/detach-user-associations/${userId}`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");
  formData.append("organizationId", $organizationId);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const deleteTmpCollab = (token, id) => {
  const requestUrl = `${TTP_API_URL}/organization/tmp-role/${id}`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const saveGoPeopleUserWithRole = async (
  organizationId,
  communityId,
  data
) => {
  try {
    const response = await goPeopleAxios.post(
      `/communities/${communityId}/organizations/${organizationId}/users`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Erreur lors de la sauvegarde de l'utilisateur"
    );
  }
};

export const updateGoPeopleUser = async (uuid, data) => {
  try {
    const response = await goPeopleAxios.put(`/users/${uuid}`, data);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la mise à jour de l'utilisateur ${uuid}`
    );
  }
};

export const updateGoPeopleUserRole = async (organization, uuid, data) => {
  try {
    const response = await goPeopleAxios.put(
      `/organizations/${organization}/users/${uuid}`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la mise à jour du rôle de l'utilisateur ${uuid}`
    );
  }
};

export const saveCollaborator = (token, data) => {
  let requestUrl = `${TTP_API_URL}/organization/user`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email[0][email]", data.email);
  formData.append("firstName", data.firstname);
  formData.append("lastName", data.lastname);
  formData.append("language", data.language);
  formData.append("isEmployee", 1);
  formData.append("isSecure", 1);

  if (data.phone) {
    formData.append("phone[0][number]", data.phone);
  } else {
    formData.append("user_type", "contact");
  }

  // if (data.exist) {
  //   formData.append("role[0][exist]", data.exist);
  // }

  if (data.roleId) {
    formData.append("role[0][id]", data.roleId);
    formData.append("role[0][type]", data.type);
    if (data.typeStatus) {
      formData.append("role[0][typeStatus]", data.typeStatus);
    }
  } else {
    formData.append("tmpRole[0][type]", data.type);
    formData.append("tmpRole[0][organization]", data.organization);
    if (data.typeStatus) {
      formData.append("tmpRole[0][typeStatus]", data.typeStatus);
    }
  }

  if (data.id) {
    formData.append("id", data.id);
  }

  if (data.emailId) {
    formData.append("email[0][id]", data.emailId);
  }

  if (data.phoneId) {
    formData.append("phone[0][id]", data.phoneId);
  }
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const importCollaborators = (token, data) => {
  let requestUrl = `${TTP_API_URL}/organization/recognizer/user`;

  var formData = new FormData();
  formData.append("access_token", token);

  if (data.data) {
    formData.append("data", data.data);
  }

  if (data.file) {
    formData.append("file", data.file);
  }

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const saveImportGoPeopleCollaborators = async (
  jwt,
  communityId,
  organizationId,
  file
) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/organizations/${organizationId}/users/import`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      body: formData,
    }
  );

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

export const saveImportCollaborators = (token, file, organization) => {
  let requestUrl = `${TTP_API_URL}/organization/users/ua-import`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("file", file);
  formData.append("organization", organization);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getEventList = (token, userId, lng, limit = 3) => {
  let cancellationTokenSource = generateCancellationTokenSource();

  let requestCancellationToken = getRequestCancellationToken(
    getEventListCTS,
    cancellationTokenSource
  );

  getEventListCTS = cancellationTokenSource;

  let requestUrl = `${TTP_API_URL}/event/event/get-list-for-user`;

  const fields = [
    "id",
    "type",
    "nameFr",
    "nameNl",
    "nameEn",
    "placeFr",
    "placeNl",
    "placeEn",
    "descriptionFr",
    "descriptionNl",
    "descriptionEn",
    "urlBannerFr",
    "urlBannerNl",
    "urlBannerEn",
    "eventDate",
    "slotsCount",
    "client",
    "memberPrice",
    "nonMemberPrice",
    "languages",
    "isReplayable",
    "accreditationHours",
    "status",
    "replayStatus",
    "labelFr",
    "labelNl",
    "labelEn",
    "speakers-abstract",
    "user-registered",
    "eventCycles",
  ];

  let params = {
    access_token: token,
    fields: fields.join(","),
    userId: userId,
    communityIds: 9,
    languages: lng,
    period: "future",
    limit: limit,
    start: 0,
  };

  let requestConfig = getRequestConfig(params, requestCancellationToken);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const saveUser = (token, data) => {
  let requestUrl = `${TTP_API_URL}/organization/user`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email[0][email]", data.email);
  formData.append("phone[0][number]", data.phone);
  formData.append("firstName", data.firstName);
  formData.append("lastName", data.lastName);
  formData.append("language", data.language);
  formData.append("gender", data.gender);
  if (data.password) formData.append("password", data.password);
  if (data.confirmPassword)
    formData.append("passwordConfirm", data.confirmPassword);
  if (data.agreation) formData.append("agreation", data.agreation);
  formData.append("isSecure", 1);
  formData.append("uaStatus", "VALIDATED");

  if (data.id) {
    formData.append("id", data.id);
  }

  if (data.role) {
    formData.append("role[0][type]", data.role.type);
    formData.append("role[0][organization]", data.role.organization);
  }

  if (data.organization_id) {
    formData.append("organization_id", data.organization_id);
  }
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const addUserExpress = ({ token, emails, fiduciaryId, language }) => {
  let requestUrl = `${TTP_API_URL}/organization/user/addExpress`;
  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("emails", emails.join(","));
  formData.append("fiduciaryId", fiduciaryId);
  formData.append("language", language);
  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};
export const saveAvatarToApi = (token, avatar) => {
  const requestUrl = `${TTP_API_URL}/organization/user/upload/profileAvatar`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("profile_avatar", avatar);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getExpressUser = ({ token, fiduciaryId, status }) => {
  let cancellationTokenSource = generateCancellationTokenSource();
  let requestCancellationToken = getRequestCancellationToken(
    getEventListCTS,
    cancellationTokenSource
  );
  let params = {
    access_token: token,
    fiduciaryId: fiduciaryId,
    status,
  };

  let requestConfig = getRequestConfig(params, requestCancellationToken);
  let requestUrl = `${TTP_API_URL}/organization/user/addExpress`;
  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const changePassword = ({ token, key, password, passwordConfirm }) => {
  let requestUrl = `${TTP_API_URL}/organization/user/newPassword`;
  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("key", key);
  formData.append("password", password);
  formData.append("passwordConfirm", passwordConfirm);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const emailReminder = ({
  token,
  id,
  uid,
  language,
  fid,
  type = "COLLABORATOR",
}) => {
  let requestUrl = `${TTP_API_URL}/organization/user/emailReminder`;
  var formData = new FormData();
  formData.append("access_token", token);
  if (uid) formData.append("uid", uid);
  if (id) formData.append("id", id);
  if (fid) formData.append("fid", fid);
  formData.append("language", language);
  formData.append("type", type);
  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

export const getUsersSettings = ({
  token,
  page = 0,
  word = "",
  organizationId,
  cancellationTokenSource = null,
}) => {
  let requestCancellationToken = getRequestCancellationToken(
    getUsersSettingsCTS,
    cancellationTokenSource
  );

  const fields = [
    "*",
    "email",
    "avatar",
    "blogRoleInOrganization",
    "role",
    "defaultSignature",
    "metas",
    "author",
  ];

  let requestUrl = `${TTP_API_URL}/organization/user/blog-setting-users?type=BLOG`;

  let filter = [];

  if (word !== "" && word.length >= 3) {
    filter.push({
      property: "name",
      value: word,
      operator: "like",
    });
  }

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    limit: 100,
    start: page * 100,
    organization_id: organizationId,
  };

  let requestConfig = getRequestConfig(params, requestCancellationToken);

  return axios
    .get(requestUrl, requestConfig)
    .then((response) => response)
    .catch((error) => {
      if (error.response && error.response.status === 403) {
        console.warn("Accès refusé aux blog-setting-users");
        return { data: [] };
      }

      throw error;
    });
};

export const saveUsersSettings = (token, data, organizationId) => {
  const requestUrl = `${TTP_API_URL}/blog/blog-role/multi-save`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("source", "ua");
  formData.append("organization_id", organizationId);

  data.forEach((user, index) => {
    formData.append(`users[${index}][id]`, user.id);
    formData.append(`users[${index}][role]`, user.role);
    formData.append(`users[${index}][mandated]`, user.mandated);
    formData.append(`users[${index}][allowCreateTags]`, user.allowCreateTags);
    user.languages.forEach((lng) => {
      formData.append(`users[${index}][allowedLanguages][]`, lng);
    });
  });
  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

export const setEmailMain = (id, token) => {
  const requestUrl = `${TTP_API_URL}/profile/email/main`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("id", id);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const setPhoneMain = (id, token) => {
  const requestUrl = `${TTP_API_URL}/profile/phone/main`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("id", id);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const updateUser = async (token, field, data) => {
  const requestUrl = `${TTP_API_URL}/organization/user`;

  var formData = new FormData();
  let requestConfig = getRequestConfig();

  formData.append("access_token", token);
  formData.append(
    field === "email" || field === "phone" ? "user" : "id",
    data.id
  );
  if (field === "name") {
    formData.append("firstName", data.firstName);
    formData.append("lastName", data.lastName);
  }
  if (field === "birthday") {
    formData.append("birthday", data.birthday);
  }
  if (field === "gender") {
    formData.append("gender", data.gender);
  }
  if (field === "language") {
    formData.append("language", data.language);
  }
  if (field === "license") {
    formData.append("agreation", data.agreation);
  }
  if (field === "email") {
    formData.append(`email`, data.email.email);
    formData.append(`main`, data.email.main);
    const emailRequestUrl = `${TTP_API_URL}/profile/email`;

    const res = await axios.post(emailRequestUrl, formData, requestConfig);
    if (res.data.data.main === 1) {
      await setEmailMain(res.data.data.id, token);
    }

    return res;
  }
  if (field === "phone") {
    formData.append(`number`, data.phone.number);
    formData.append(`main`, data.phone.main);
    const phoneRequestUrl = `${TTP_API_URL}/profile/phone`;

    const res = await axios.post(phoneRequestUrl, formData, requestConfig);
    if (res.data.data.main === 1) {
      await setPhoneMain(res.data.data.id, token);
    }

    return res;
  }
  if (field === "password") {
    formData.append(`oldPassword`, data.oldPassword);
    formData.append(`password`, data.password);
    formData.append(`passwordConfirm`, data.passwordConfirm);
    const passwordRequestUrl = `${TTP_API_URL}/organization/user/changePassword`;

    return axios.post(passwordRequestUrl, formData, requestConfig);
  }

  return axios.post(requestUrl, formData, requestConfig);
};

export const deleteGoPeopleUser = async (uuid) => {
  try {
    const response = await goPeopleAxios.delete(`/users/${uuid}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la suppression de l'utilisateur ${uuid}`
    );
  }
};

export const dessociateGoPeopleUser = async (organizationId, uuid) => {
  try {
    const response = await goPeopleAxios.delete(
      `/organizations/${organizationId}/organizationsuserrole/${uuid}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la désassociation du rôle ${uuid}`
    );
  }
};

export const deleteExpressUser = (token, id) => {
  const requestUrl = `${TTP_API_URL}/organization/user/delete-user-express/${id}`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const deleteEmailApi = (id, token) => {
  const requestUrl = `${TTP_API_URL}/profile/email/${id}`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("_method", "delete");
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const deletePhoneApi = (id, token) => {
  const requestUrl = `${TTP_API_URL}/profile/phone/${id}`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("_method", "delete");
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const resetPassword = (token, email) => {
  let requestUrl = `${TTP_API_URL}/organization/user/resetPassword`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  formData.append("source", "ua");
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const saveContact = async (token, data, communityId) => {
  let requestUrl = `${TTP_API_URL}/mailing/contact/ua-save`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email[0][email]", data.email);
  formData.append("firstName", data.firstname);
  formData.append("lastName", data.lastname);
  formData.append("gender", data.gender);
  formData.append("language", data.language);
  formData.append("user_type", "contact");
  formData.append("is_contact", 1);
  formData.append("client", communityId);
  formData.append("details", JSON.stringify(data.details));

  if (data.phone) {
    formData.append("phone[0][number]", data.phone);
  }

  if (data.userID) {
    formData.append("id", data.userID);
  }

  if (data.emailId) {
    formData.append("email[0][id]", data.emailId);
  }

  if (data.phoneId) {
    formData.append("phone[0][id]", data.phoneId);
  }

  if (data.type) {
    formData.append("type", data.type);
  }

  /*var contactData = new FormData();
  contactData.append("access_token", token);
  contactData.append("client", communityId);
  contactData.append("details", JSON.stringify(data.details));
  if (!data.fetchedUser) {
    const userRes = await axios.post(requestUrl, formData);
    if (userRes && userRes.data.data.id) {
      contactData.append("id", userRes.data.data.id);
    }
  } else {
    contactData.append("id", data.fetchedUser.id);
  }

  if (data.fetchedFolder) {
    contactData.append("folderId", data.fetchedFolder.id);
  }
  if (data.oldFetchedFolder) {
    contactData.append("oldFolderId", data.oldFetchedFolder);
  }*/

  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

export const getContactsByFolder = async (communityId, organizationId, jwt) => {
  try {
    const response = await goPeopleAxios.get(
      `/communities/${communityId}/folders/${organizationId}/contacts`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération des contacts du dossier ${folderId}`
    );
  }
};

export const getGoPeopleContactsFilter = async (communityId, groupsIn) => {
  try {
    let params = {
      filter: { contact_groups: { $in: groupsIn } },
      include_ttp_user_ids: true,
    };

    const response = await goPeopleAxios.get(
      `/communities/${communityId}/contacts/filter`,
      {
        params,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération des contacts de la communauté ${communityId}`
    );
  }
};

export const getGoPeopleContacts = async (
  communityId,
  groupsIn,
  groupsNotIn,
  limit,
  page
) => {
  try {
    let params = { limit, offset: (page - 1) * limit };
    if (groupsIn.length) {
      params = { ...params, groups_in: groupsIn.join(",") };
    }
    if (groupsNotIn.length) {
      params = { ...params, groups_not_in: groupsNotIn.join(",") };
    }
    const response = await goPeopleAxios.get(
      `/communities/${communityId}/contacts?fields[contact]=contact_groups,phones,ttp_contact_id,ttp_user_id,genre,language,function`,
      {
        params,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération des contacts de la communauté ${communityId}`
    );
  }
};

export const saveGoPeopleContact = async (communityId, data) => {
  try {
    const response = await goPeopleAxios.post(
      `/communities/${communityId}/contacts`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la création du contact dans la communauté ${communityId}`
    );
  }
};

export const saveGoPeopleFolderContact = async (
  communityId,
  folderId,
  data
) => {
  try {
    const response = await goPeopleAxios.post(
      `/communities/${communityId}/folders/${folderId}/contacts`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la création du contact dans le dossier ${folderId}`
    );
  }
};

export const getContacts = ({
  token,
  sort,
  search,
  start,
  limit,
  page,
  communityId,
  filterGroups,
  excludeGroups,
  contactNl,
  fields,
}) => {
  let cancellationTokenSource = generateCancellationTokenSource();

  let requestCancellationToken = getRequestCancellationToken(
    getContactsCTS,
    cancellationTokenSource
  );
  getContactsCTS = cancellationTokenSource;

  let requestUrl = `${TTP_API_URL}/mailing/contact`;
  const filter = [
    { property: "client.id", value: communityId, operator: "eq" },
  ];
  if (search) {
    filter.push(
      ...[
        { property: "name", value: search, operator: "like" },
        { property: "email.main", value: 1, operator: "eq" },
      ]
    );
  }

  if (filterGroups && filterGroups.length > 0) {
    filter.push({
      property: "group.id",
      value: [...filterGroups],
      operator: "in",
    });
  }
  if (excludeGroups && excludeGroups.length > 0) {
    filter.push({
      property: "group.id",
      value: [...excludeGroups],
      operator: "nin",
    });
  }
  if (contactNl) {
    filter.push({
      property: "contactClient.type",
      value: "CONTACT_NL",
      operator: "eq",
    });
  }

  let params = {
    filter: JSON.stringify(filter),
    access_token: token,
    fields: fields ?? "*,contactClient,email,phone,group",
    start: page ? (page - 1) * limit : start,
    limit,
  };

  if (sort) {
    params["sort"] = JSON.stringify([sort]);
  }

  let requestConfig = getRequestConfig(params, requestCancellationToken);
  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const deleteGoPeopleContact = async (communityId, contactId) => {
  try {
    const response = await goPeopleAxios.delete(
      `/communities/${communityId}/contacts/${contactId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la suppression du contact ${contactId} dans la communauté ${communityId}`
    );
  }
};

export const deleteContact = (token, id) => {
  const requestUrl = `${TTP_API_URL}/organization/contact-client/${id}`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const emailAcceptInvitation = (token, uid, id, email, fiduciaryId) => {
  let requestUrl = `${TTP_API_URL}/profile/email/accept-invitation`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  if (uid) {
    formData.append("uid", uid);
  }
  if (id) {
    formData.append("id", id);
  }
  if (fiduciaryId) {
    formData.append("fid", fiduciaryId);
  }

  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

export const emailRejectInvitation = (token, uid, id, email, fiduciaryId) => {
  let requestUrl = `${TTP_API_URL}/profile/email/reject-invitation`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  if (uid) {
    formData.append("uid", uid);
  }
  if (id) {
    formData.append("id", id);
  }
  if (fiduciaryId) {
    formData.append("fid", fiduciaryId);
  }

  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

const publicAxios = axios.create({
  baseURL: GOPEOPLE_API_URL,
});

export const acceptEmailInvitationGo = async (token) => {
  try {
    const response = await axios
      .create({
        baseURL: GOPEOPLE_API_URL,
      })
      .post(`/invitations/accept`, { token });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectEmailInvitationGo = async (token) => {
  try {
    const response = await axios
      .create({
        baseURL: GOPEOPLE_API_URL,
      })
      .post(`/invitations/reject`, { token });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const setUserPassword = async (newPassword, token) => {
  try {
    const response = await axios
      .create({
        baseURL: GOPEOPLE_API_URL,
      })
      .post(
        `/auth/password`,
        { newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveRole = (token, organizationId) => {
  let requestUrl = `${TTP_API_URL}/organization/user/addTmpRole`;
  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

export const saveImportGoPeopleContacts = async (jwt, communityId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/contacts/import`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      body: formData,
    }
  );

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

export const saveImportContacts = (token, file, communityId) => {
  let requestUrl = `${TTP_API_URL}/mailing/contact/ua-import`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("file", file);
  formData.append("client", communityId);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);

  /*
  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("client", communityId);
  data.forEach((item, i) => {
    formData.append(`firstName[${i}]`, item[0]);
    formData.append(`lastName[${i}]`, item[1]);
    formData.append(`email[${i}]`, item[2]);
    formData.append(`phone[${i}]`, item[3]);
    formData.append(`language[${i}]`, item[4]);
    formData.append(`uen[${i}]`, item[5].replace(/\.|\s|BE|be/g, ""));
    formData.append(`Uname[${i}]`, item[6]);
    formData.append(`fonction[${i}]`, item[7]);
    formData.append(
      `details[${i}]`,
      JSON.stringify({
        uen: item[5].replace(/\.|\s|BE|be/g, ""),
        name: item[6],
        fonction: item[7],
        isClient: false,
      })
    );
  });
  return axios.post(requestUrl, formData);
  */
};

export const getGroupByName = (token, name, communityId) => {
  let cancellationTokenSource = generateCancellationTokenSource();

  let requestCancellationToken = getRequestCancellationToken(
    getGroupsCTS,
    cancellationTokenSource
  );
  getGroupsCTS = cancellationTokenSource;

  let requestUrl = `${TTP_API_URL}/mailing/group`;
  let params = {
    access_token: token,
    fields: "*",
  };

  if (name) {
    params.filter = JSON.stringify([
      {
        property: "name",
        value: name,
        operator: "like",
      },
      { property: "client.id", value: communityId, operator: "eq" },
    ]);
  }

  let requestConfig = getRequestConfig(params, requestCancellationToken);
  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const addContactToGroup = (token, data, communityId) => {
  let requestUrl = `${TTP_API_URL}/mailing/group/create-contacts`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("client", communityId);
  formData.append("category", "CONTACT");
  formData.append("group[name]", data.group.name);
  if (data.group.id) {
    formData.append("group[id]", data.group.id);
  }
  data.contacts.forEach((element, i) => {
    formData.append(`contactsIds[${i}]`, element);
  });
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const removeContactFromGroup = (token, data) => {
  let requestUrl = `${TTP_API_URL}/mailing/group/delete-contacts`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("category", "CONTACT");
  if (data.group.id) {
    formData.append("groupId", data.group.id);
  }
  data.contacts.forEach((element, i) => {
    formData.append(`contactsIds[${i}]`, element);
  });
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getGoPeopleGroups = async (jwt, communityId) => {
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/contact-groups`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    }
  );

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

// Same endpoint as getGoPeopleGroups; without `q` it returns all groups.
export const searchGoPeopleGroups = async (jwt, communityId, q = "", limit = 50) => {
  const params = new URLSearchParams({ limit: String(limit) });
  if (q) {
    params.set("q", q);
  }
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/contact-groups?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    }
  );

  if (response.ok) {
    return response.json();
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

export const createGoPeopleGroup = async (jwt, communityId, name) => {
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/contact-groups`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify({ name }),
    }
  );

  if (response.ok) {
    return response.json();
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

export const assignGroupToContact = async (
  jwt,
  communityId,
  contactRef,
  groupRef
) => {
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/contacts/${contactRef}/groups/${groupRef}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    }
  );

  if (response.ok) {
    return response.json().catch(() => ({}));
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

export const removeGroupFromContact = async (
  jwt,
  communityId,
  contactRef,
  groupRef
) => {
  const response = await fetch(
    `${GOPEOPLE_API_URL}/communities/${communityId}/contacts/${contactRef}/groups/${groupRef}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    }
  );

  if (response.ok) {
    return response.json().catch(() => ({}));
  } else {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}`
    );
  }
};

// No native bulk endpoint on GoPeople — fan out parallel calls, report partial failures.
export const bulkAssignGroupToContacts = async (
  jwt,
  communityId,
  contactRefs,
  groupRef
) => {
  const results = await Promise.allSettled(
    contactRefs.map((ref) =>
      assignGroupToContact(jwt, communityId, ref, groupRef)
    )
  );

  const succeeded = [];
  const failed = [];
  results.forEach((result, index) => {
    if (result.status === "fulfilled") {
      succeeded.push(contactRefs[index]);
    } else {
      failed.push({
        ref: contactRefs[index],
        reason: result.reason?.message || String(result.reason),
      });
    }
  });

  return { succeeded, failed };
};

export const getGroups = ({ token, communityId }) => {
  let requestUrl = `${TTP_API_URL}/mailing/group`;
  const filter = [
    { property: "client.id", value: communityId, operator: "eq" },
  ];
  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    nolimit: 1,
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const clientAcceptInvitation = (token, uid, email, fiduciaryId) => {
  let requestUrl = `${TTP_API_URL}/profile/email/accept-client-invitation`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  if (uid) {
    formData.append("uid", uid);
  }
  if (fiduciaryId) {
    formData.append("fid", fiduciaryId);
  }
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const clientRejectInvitation = (token, uid, email, fiduciaryId) => {
  let requestUrl = `${TTP_API_URL}/profile/email/reject-client-invitation`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  if (uid) {
    formData.append("uid", uid);
  }
  if (fiduciaryId) {
    formData.append("fid", fiduciaryId);
  }
  let requestConfig = getRequestConfig();
  return axios.post(requestUrl, formData, requestConfig);
};

export const getThemeGroups = ({
  token,
  clientId = null,
  customFilter = null,
}) => {
  const requestUrl = `${TTP_API_URL}/mailing/group`;
  let filter = [
    {
      property: "client.id",
      value: clientId,
      operator: "eq",
    },
  ];

  if (customFilter !== null && Array.isArray(customFilter)) {
    filter.push(...customFilter);
  }
  let params = {
    access_token: token,
    nolimit: 1,
    fields: "id, name",
    filter: JSON.stringify(filter),
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};
export const getUsers = ({ token, search, organizationId }) => {
  let cancellationTokenSource = generateCancellationTokenSource();
  // getGroupsCTS
  let requestCancellationToken = getRequestCancellationToken(
    getCollaboratorsCTS,
    cancellationTokenSource
  );
  getCollaboratorsCTS = cancellationTokenSource;

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "organization.id",
      value: organizationId,
      operator: "eq",
    },
  ];

  if (search) {
    filter.push({ property: "name", value: search, operator: "like" });
    filter.push({ property: "email.main", value: 1, operator: "eq" });
  }

  let params = {
    access_token: token,
    fields: "*",
    start: 0,
    filter: JSON.stringify(filter),
    limit: 20,
    workspace: "ua",
  };

  let requestConfig = getRequestConfig(params, requestCancellationToken);
  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getUserHasFiduciaryPlan = (token) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-membership/has-fiduciary-plan`;

  let params = {
    access_token: token,
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const saveOECCBBMember = async (token, data, communityId) => {
  let requestUrl = `${TTP_API_URL}/mailing/contact/oeccbb-save`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email[0][email]", data.email);
  formData.append("firstName", data.firstname);
  formData.append("lastName", data.lastname);
  formData.append("user_type", "contact");
  formData.append("is_contact", 1);
  formData.append("client", communityId);

  formData.append("year", data.year);
  formData.append("formula", data.formula);

  if (data.phone) {
    formData.append("phone[0][number]", data.phone);
  }

  if (data.userID) {
    formData.append("id", data.userID);
  }

  if (data.emailId) {
    formData.append("email[0][id]", data.emailId);
  }

  if (data.phoneId) {
    formData.append("phone[0][id]", data.phoneId);
  }
  formData.append("uen", data.uen);
  formData.append("organization", data.organization);
  formData.append("address", data.address);
  formData.append("postalCode", data.postalCode);
  formData.append("country", data.city);
  formData.append("billingSubjectToVAT", data.subjectToVAT ? 1 : 0);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const checkContacts = (token, file, communityId) => {
  let requestUrl = `${TTP_API_URL}/mailing/contact/ua-check`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("file", file);
  formData.append("client", communityId);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getStudentInfos = (token, userId, organizationId) => {
  let requestUrl = `${TTP_API_URL}/organization/user/get-student-infos`;

  let params = {
    access_token: token,
    userId,
    organization: organizationId,
    workspace: "ua",
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const profileCheckMail = ({ token, email, userId, language }) => {
  let requestUrl = `${TTP_API_URL}/profile/email/check-mail`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  formData.append("userId", userId);
  formData.append("language", language);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const profileValidateMail = ({ token, email, userId, key }) => {
  let requestUrl = `${TTP_API_URL}/profile/email/validate-mail`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  formData.append("userId", userId);
  formData.append("key", key);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const profileCheckPhone = ({ token, phone, userId, language }) => {
  let requestUrl = `${TTP_API_URL}/profile/phone/check-phone`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("phone", phone);
  formData.append("userId", userId);
  formData.append("language", language);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const profileValidatePhone = ({ token, phone, userId, key }) => {
  let requestUrl = `${TTP_API_URL}/profile/phone/validate-phone`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("phone", phone);
  formData.append("userId", userId);
  formData.append("key", key);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getUserArchiveHistory = (token, id) => {
  let fields = ["*", "archiveHistory"];

  let requestUrl = `${TTP_API_URL}/organization/user`;

  const filter = [
    {
      property: "id",
      value: id,
      operator: "eq",
    },
  ];

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    workspace: "ua",
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const saveAgreation = ({ token, userId, data }) => {
  const requestUrl = `${TTP_API_URL}/event/user/save-agreation-data`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("user", userId);
  formData.append("userAgreationData", data);
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getNotifications = ({
  token,
  userId,
  navCommunity,
  appName,
  loggedAsAdmin,
  options,
}) => {
  let filter = [
    {
      property: "status",
      value: "PUBLISHED",
      operator: "eq",
    },
    {
      property: "appName",
      value: appName,
      operator: "like",
    },
  ];
  if (navCommunity) {
    filter.push({
      property: "folder",
      value: navCommunity.id,
      operator: "eq",
    });
  } else {
    filter.push({
      property: "folder",
      value: "",
      operator: "null",
    });
  }

  let fields = ["*", "isRead", "introduction"];
  let sort = [
    {
      property: "publishedAt",
      dir: "desc",
    },
  ];

  const requestUrl = `${TTP_API_URL}/blog/notification-user/${userId}`;

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    sort: JSON.stringify(sort),
    limit: options && options.limit ? options.limit : 10,
  };
  if (loggedAsAdmin) {
    params.is_admin = 1;
  }

  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getOrganizationSettingsOrg = (token, organizationId) => {
  const requestUrl = `${TTP_API_URL}/organization/organization-settings`;
  if (!token) {
    return Promise.reject(new Error("Token is required"));
  }
  if (!organizationId) {
    return Promise.reject(new Error("organizationId is required"));
  }

  const params = {
    access_token: token,
    id: organizationId,
  };

  return axios.get(requestUrl, { params }).then((response) => response.data);
};

export const updateGoPeopleSelectedOrganization = async (
  communityId,
  organizationId
) => {
  if (!organizationId) {
    return Promise.reject(new Error(" organizationId are required"));
  }

  try {
    const data = { communityId, organizationId };
    const response = await goPeopleAxios.put(
      `/users/me/selected-organization`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la mise à jour de l'organisation sélectionnée`
    );
  }
};

export const getGoPeopleCommunityOrganization = async ({
  userId,
  organizationId,
}) => {
  if (!userId || !organizationId) {
    return Promise.reject(new Error("userId et organizationId sont requis"));
  }

  try {
    const response = await goPeopleAxios.get(
      `/organisations/${organizationId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération de l'organisation ${organizationId}`
    );
  }
};

export const getGoPeopleFiduciaire = async ({ communityId }) => {
  try {
    const response = await goPeopleAxios.get(`/organizations/${communityId}`);
    return { data: { data: [response.data] } };
  } catch (error) {
    throw new Error(
      // error.response?.data?.message ||
      // error.response?.data?.error ||
      error ||
        `Erreur lors de la récupération des informations fiduciaires de ${communityId}`
    );
  }
};

export const getGoPeopleOrganizationsCommunity = async () => {
  try {
    const response = await goPeopleAxios.get(`/user/organizations`);
    return response;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération du profil utilisateur`
    );
  }
};

export const getGoPeopleUserProfile = async () => {
  try {
    const response = await goPeopleAxios.get(
      `/users/me/complete-profile?fields[user]=is_ua_admin`
    );
    return { data: { data: [response.data] } };
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de la récupération du profil utilisateur`
    );
  }
};

export const getUserRoleDelegations = ({ token, userId }) => {
  const requestUrl = `${TTP_API_URL}/organization/folder/user-roles-delegations/${userId}`;

  let params = {
    access_token: token,
  };

  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const resendInvitation = async ({
  communityId,
  organizationId,
  userId,
  lng,
}) => {
  if (!communityId || !organizationId || !userId) {
    return Promise.reject(
      new Error("communityId, organizationId et userId sont requis")
    );
  }

  try {
    const response = await goPeopleAxios.post(
      `/communities/${communityId}/organizations/${organizationId}/users/${userId}/resend-invitation`,
      null,
      {
        params: lng ? { lng } : {},
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors du renvoi de l'invitation pour l'utilisateur ${userId}`
    );
  }
};

export const archiveUser = (token, userId, reason = "", description = "") => {
  let requestUrl = `${TTP_API_URL}/organization/user/archive`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("user", userId);
  if (reason) formData.append("reason", reason);
  if (description) formData.append("description", description);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const archiveGoPeopleContact = async (
  communityId,
  contactId,
  reason = "",
  description = ""
) => {
  try {
    const response = await goPeopleAxios.put(
      `/communities/${communityId}/contacts/${contactId}`,
      {
        archived: true,
        archive_reason: reason,
        archive_description: description,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        `Erreur lors de l'archivage du contact ${contactId}`
    );
  }
};
